import axios from 'axios'
import {
    Message,
    MessageBox
} from 'element-ui'

// 创建axios实例
const service = axios.create({
    baseURL: '', // api 的 base_url
    timeout: 60000 // 请求超时时间
})

axios.defaults.headers.post['Content-Type'] = 'x-www-form-urlencoded;charset=UTF-8';

// request拦截器

service.interceptors.request.use(
    config => {
            if(config.url.indexOf("token") != -1 ){

            }else{
                // config.headers['Authorization'] = `Bearer ${sessionStorage.getItem("token")}`; // 让每个请求携带自定义token 请根据实际情况自行修改
            }
      return config
    },
    error => {
      // Do something with request error
      Promise.reject(error)
    }
  )
// response 拦截器
service.interceptors.response.use(
    response => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        return response.data

    },
    error => {
        // error.msg
        Message({
            message: '请求超时',
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject(error)
    }
)

export default service
